import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { FixedComponentsRateChartService } from "./fixed-components-rate-chart-service";
import { FixedComponentsRateChart } from "./fixed-components-rate-chart-entity";
import { FixedComponentsRateChartController } from "./fixed-components-rate-chart-controller";
import { FixedComponentsRateChartLogs } from "./fixed-components-log-entity";

@Module({
    imports:[
        TypeOrmModule.forFeature([FixedComponentsRateChart,FixedComponentsRateChartLogs])
    ],
    providers:[FixedComponentsRateChartService,ApplicationExceptionHandler],
    controllers:[FixedComponentsRateChartController],
    exports:[FixedComponentsRateChartService]
})
export class FixedComponentsRateModule{}